import $foreign from "./foreign.cjs";
var _new = $foreign._new;
var get_adjustedHeight = $foreign.get_adjustedHeight;
var get_changedAt = $foreign.get_changedAt;
var get_dependents = $foreign.get_dependents;
var get_height = $foreign.get_height;
var get_name = $foreign.get_name;
var get_observers = $foreign.get_observers;
var get_source = $foreign.get_source;
var get_value = $foreign.get_value;
var set_adjustedHeight = $foreign.set_adjustedHeight;
var set_changedAt = $foreign.set_changedAt;
var set_height = $foreign.set_height;
var set_name = $foreign.set_name;
var set_value = $foreign.set_value;
export { _new, get_adjustedHeight, get_changedAt, get_dependents, get_height, get_name, get_observers, get_source, get_value, set_adjustedHeight, set_changedAt, set_height, set_name, set_value };
